
import Modal from "react-bootstrap/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  openServiceListDisplayModel,
  setPackageAndServiceModelFalse,
} from "../../store/slices/modalSlice";
import { useEffect, useState } from "react";
import { RootState } from "../../store/store"; // Update the path if your store file is at src/store/store.ts
import { IndividualService, VisaPackage } from "../../types/callPackage";
import { useCart } from "../../hooks/useCart";
import axios from "axios";

const baseUrl = import.meta.env.VITE_API_URL;
interface ApplicantData {
  applicantCountry: string;
  applicantName: string;
  applicantPassport: string;
  cartId: number | null;
  heading: string;
  packageName: string;
  selectedFilter: string[];
  serviceDetails: {
    serviceId: number;
    serviceName: string;
  }[];
  totalPrice: number;
}

const PackageAndSerivceModel = () => {
  const dispatch = useDispatch();
  const { getData } = useCart();
  const [applicantData, setApplicantData] = useState<ApplicantData | null>(
    null
  );

  const OpenPackageAndServiceModel = useSelector(
    (state: RootState) => state.modal.packageAndServiceModel
  );

  const CartItems = useSelector((state: RootState) => state.ID.CartItems);

  const modelTitle = useSelector((state: RootState) => state.ID.modelTitle);

  const fromDeleteService = useSelector(
    (state: RootState) => state.ID.fromDeleteService
  );

  const serviceListData = useSelector(
    (state: RootState) => state.ID.serviceListData
  );

  const clickedCartId = useSelector(
    (state: RootState) => state.ID.clickedCartId
  );

  const handleCloseReadFullPolicy = () => {
    if (fromDeleteService) {
      dispatch(openServiceListDisplayModel(serviceListData));
    }
    dispatch(setPackageAndServiceModelFalse());
  };

  useEffect(() => {
    const packageLength = CartItems?.packages?.length || 0;
    const serviceLength = CartItems?.services?.length || 0;


    if (packageLength === 0 && serviceLength === 0) {
      getData();
    }
  });
  useEffect(() => {
    if (
      (modelTitle === "Package" || modelTitle === "package") &&
      clickedCartId
    ) {
      const foundItem = CartItems?.packages?.find(
        (item: VisaPackage) => item.cartId === clickedCartId
      );

      if (foundItem) {
        const formattedItem: ApplicantData = {
          applicantCountry: foundItem.applicantCountry || "",
          applicantName: foundItem.applicantName || "",
          applicantPassport: foundItem.applicantPassport || "",
          cartId: foundItem.cartId || null,
          heading: foundItem.heading || "",
          packageName: foundItem.packageName || "",
          selectedFilter: foundItem.selectedFilter || [],
          serviceDetails: foundItem.serviceDetails || [],
          totalPrice: foundItem.totalPrice || 0,
        };

        setApplicantData(formattedItem);
      }
    } else {
      const foundItem = CartItems?.services?.find(
        (item: IndividualService) => item.cartID === clickedCartId
      );

      if (foundItem) {
        const formattedItem: ApplicantData = {
          applicantCountry: foundItem.applicantCountry || "",
          applicantName: foundItem.applicantname || "",
          applicantPassport: foundItem.applicantPassport || "",
          cartId: foundItem.cartID || null,
          heading: foundItem.heading || "",
          packageName: foundItem.serviceName || "",
          selectedFilter: foundItem.selectedFilter || [],
          serviceDetails: foundItem.serviceDetails || [],
          totalPrice: foundItem.PriceAmount || 0,
        };

        setApplicantData(formattedItem);
      }
    }
  }, [CartItems, clickedCartId, modelTitle]);

  const handleDeleteService = async (cartId: number | null | undefined) => {
    if (cartId) {
      try {
        const response = await axios.delete(
          `${baseUrl}/api/cart/deleteCartItem?cartId=${cartId}`
        );
        if (response.data) {
          await getData(); // Refresh cart data
          dispatch(setPackageAndServiceModelFalse()); // Close modal

          if (window.location.href.includes("uploadocument")) {
            window.location.reload();
          }
        }
      } catch (error) {
        console.error("Error deleting cart item:", error);
        throw error; // optional: rethrow if needed
      }
    }
  };

  return (
    <>
      <Modal
        show={OpenPackageAndServiceModel}
        onHide={handleCloseReadFullPolicy}
        backdrop="static"
        centered
        className="mb-fix slide-from-bottom "
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body className=" rounded-top modal-body">
          <div>
            {fromDeleteService && (
              <div className="">
                <p className="p-2 bg-light-red text-red ff-semibold font-14 d-flex align-items-center gap-2 rounded-2 px-3">
                  <img
                    src="https://goodhand.b-cdn.net/Assets/Upload/up-delete.svg"
                    alt=""
                  ></img>
                  Are you sure you want to delete this {modelTitle}
                </p>
              </div>
            )}
            <p className="font-17 ff-semibold text-black mb-1">
              {modelTitle} Detail
            </p>
            <div className="cart-details">
              <div className="d-flex justify-content-between align-items-center gap-1 mb-1">
                <div className="product-name">
                  <p className="checkout-ser-name font-13 mb-0 ff-medium text-black">
                    {applicantData?.packageName}
                  </p>
                </div>
                <div>
                  <span className="main-price pt-1 ff-bold text-end d-block font-14 text-black">
                    <span className="ff-currency ff-medium  font-16"></span>
                    {applicantData?.totalPrice}
                  </span>
                </div>
              </div>
              <div className="address-container d-flex flex-wrap align-items-center gap-2 pt-2 pb-2 mb-1 bg-2 p-2 rounded-2">
                <div className="address-icon-container">
                  <div className="address-icon">
                    <span
                      className={`flag-icon flag-icon-${
                        applicantData?.applicantCountry?.toLowerCase() || "ae"
                      } me-1`}
                    ></span>
                  </div>
                </div>
                <div className="address-text-container">
                  <p className="address-text mb-0 font-14 ff-semibold text-main cursor-pointer">
                    {applicantData?.applicantName}
                  </p>
                </div>

                <div className="address-text-container">
                  <p className="address-text mb-0 font-14 ff-semibold text-dark cursor-pointer">
                    {applicantData?.applicantPassport}
                  </p>
                </div>
              </div>

              {applicantData?.selectedFilter &&
                applicantData?.selectedFilter?.length > 0 && (
                  <div className="cart-options mb-1">
                    <p className="options-title ff-medium text-black my-2 font-13">
                      Options Selected for visa
                    </p>
                    <div className="options-list d-flex gap-2">
                      {applicantData?.selectedFilter.map((item) => (
                        <span
                          key={item}
                          className="option category px-2 py-1 rounded-pill bg-3 text-main ff-semibold font-12 "
                        >
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

              {applicantData?.serviceDetails &&
                applicantData?.serviceDetails?.length > 0 && (
                  <div className="cart-services">
                    <p className="options-title ff-semibold text-black my-2 font-12">
                      Service includes
                    </p>
                    <ul className="services-list-package-main font-13">
                      {applicantData?.serviceDetails.map((item) => (
                        <li
                          key={item.serviceId}
                          dangerouslySetInnerHTML={{
                            __html: item.serviceName ?? " ",
                          }}
                        ></li>
                      ))}
                    </ul>
                  </div>
                )}
            </div>
          </div>{" "}
        </Modal.Body>
        <Modal.Footer className="p-0 border-0 rounded-0 shadow-none border-top modal-footer">
          <div className="d-flex align-items-center justify-content-between w-100 px-3 py-2 gap-3">
            {fromDeleteService ? (
              <>
                <button
                  className="btn btn-primary bg-2 w-100 font-14 ff-semibold py-3 text-black  bt--cart"
                  onClick={handleCloseReadFullPolicy}
                >
                  NO
                </button>
                <button
                  className="btn btn-primary w-100 font-14 ff-semibold py-3 bt--cart bg-red"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteService(applicantData?.cartId);
                  }}
                >
                  DELETE
                </button>
              </>
            ) : (
              <button
                className="btn btn-primary w-100 font-14 ff-semibold py-3 bt--cart"
                onClick={handleCloseReadFullPolicy}
              >
                OkAY, GOT IT
              </button>
            )}
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default PackageAndSerivceModel;
